import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import { CropImage, CropImageProps } from './CropImage';

interface Props extends CropImageProps {
  isOpen: boolean;
  onClose(): void;
}

export const CropImageModal = (props: Props) => {
  const { isOpen, onClose, content, ...rest } = props;

  const { title } = content;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent data-testid="crop-image-modal">
        <ModalHeader as={Center} fontWeight="light" fontSize="1.25rem">
          {title}
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <CropImage {...rest} content={content} onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
